/**
 * A link the platform may render as "Open in Drive": https on a Google host, no credentials. Drive links come back from
 * the backend but are built from what Drive reported, so anything else is dropped rather than rendered.
 */
export const safeDriveLink = (link: string | null | undefined): string | undefined => {
  if (!link) return undefined;
  let parsed: URL;
  try {
    parsed = new URL(link);
  } catch {
    return undefined;
  }
  if (parsed.protocol !== 'https:' || parsed.username || parsed.password) return undefined;
  const host = parsed.hostname.toLowerCase();

  return host === 'google.com' || host.endsWith('.google.com') ? parsed.toString() : undefined;
};

/** A Drive-hosted file pointer, as the backend serialises it (`type: 'gdrive'`). */
export const isDriveHostedPointer = (
  pointer: unknown,
): pointer is { type: 'gdrive'; webViewLink?: string; name?: string; mimeType?: string } =>
  typeof pointer === 'object' &&
  pointer !== null &&
  (pointer as { type?: unknown }).type === 'gdrive';
